import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';

import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { GroupViewImpl } from './groupview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { GroupCSSStyleImpl } from './groupcss';
import { ManageGroupType } from './managegroup/managegrouptype';
import { GroupDto, GroupDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/listtones/groupdto';


export interface GroupComponentProps extends CRBTUIComponentProps
{

}

export interface GroupComponentState extends UIComponentState
{
    manageGroupType: ManageGroupType;
    groupDto: GroupDto;
}


export interface GroupHandler extends UIComponentHandler
{
    updateType(manageGroupType: ManageGroupType, groupDto: GroupDto): void;
    onCancelClicked(): void;
}

export class GroupComponent extends CRBTUIComponent<GroupComponentProps, UIComponentState> implements GroupHandler
{ 
    constructor(props: GroupComponentProps)
    {
        super(props);

        this.state = {manageGroupType: ManageGroupType.LIST, groupDto: new GroupDtoImpl()};
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
    }

    updateType(manageGroupType: ManageGroupType, groupDto: GroupDto): void {
        this.setState({manageGroupType: manageGroupType, groupDto: groupDto});
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GroupViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GroupCSSStyleImpl(applicationContext);
    }

    onCancelClicked(): void {
        this.setState({manageGroupType: ManageGroupType.LIST});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/groupcomponent.tsx